// extracted by mini-css-extract-plugin
module.exports = {"root":"Images45_root__2-KF7","title":"Images45_title__3Jor8","images":"Images45_images__3dHKZ"};